/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberAppointmentsIdStartMutationResponse, PostApiBarberAppointmentsIdStartPathParams, PostApiBarberAppointmentsIdStart400, PostApiBarberAppointmentsIdStart401, PostApiBarberAppointmentsIdStart403, PostApiBarberAppointmentsIdStart404, PostApiBarberAppointmentsIdStart500 } from "../entities/PostApiBarberAppointmentsIdStart";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBarberAppointmentsIdStart } from "../api/postApiBarberAppointmentsIdStart";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBarberAppointmentsIdStartMutationKey = () => [{ url: '/api/barber/appointments/:id/start' }] as const

export type PostApiBarberAppointmentsIdStartMutationKey = ReturnType<typeof postApiBarberAppointmentsIdStartMutationKey>

export function postApiBarberAppointmentsIdStartMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = postApiBarberAppointmentsIdStartMutationKey()
        return mutationOptions<PostApiBarberAppointmentsIdStartMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdStart400 | PostApiBarberAppointmentsIdStart401 | PostApiBarberAppointmentsIdStart403 | PostApiBarberAppointmentsIdStart404 | PostApiBarberAppointmentsIdStart500>, {id: PostApiBarberAppointmentsIdStartPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return postApiBarberAppointmentsIdStart(id, config)
          },
        })

}

/**
 * @description Мастер начинает обслуживание после вызова клиента
 * @summary Начать обслуживание
 * {@link /api/barber/appointments/:id/start}
 */
export function usePostApiBarberAppointmentsIdStart<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBarberAppointmentsIdStartMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdStart400 | PostApiBarberAppointmentsIdStart401 | PostApiBarberAppointmentsIdStart403 | PostApiBarberAppointmentsIdStart404 | PostApiBarberAppointmentsIdStart500>, {id: PostApiBarberAppointmentsIdStartPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBarberAppointmentsIdStartMutationKey()

          const baseOptions = postApiBarberAppointmentsIdStartMutationOptions(config) as UseMutationOptions<PostApiBarberAppointmentsIdStartMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdStart400 | PostApiBarberAppointmentsIdStart401 | PostApiBarberAppointmentsIdStart403 | PostApiBarberAppointmentsIdStart404 | PostApiBarberAppointmentsIdStart500>, {id: PostApiBarberAppointmentsIdStartPathParams["id"]}, TContext>
          

          return useMutation<PostApiBarberAppointmentsIdStartMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdStart400 | PostApiBarberAppointmentsIdStart401 | PostApiBarberAppointmentsIdStart403 | PostApiBarberAppointmentsIdStart404 | PostApiBarberAppointmentsIdStart500>, {id: PostApiBarberAppointmentsIdStartPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBarberAppointmentsIdStartMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdStart400 | PostApiBarberAppointmentsIdStart401 | PostApiBarberAppointmentsIdStart403 | PostApiBarberAppointmentsIdStart404 | PostApiBarberAppointmentsIdStart500>, {id: PostApiBarberAppointmentsIdStartPathParams["id"]}, TContext>
      
}